import { ParametersDeclaration } from '@games/core/parameters';

export interface BlindReadingParameters {
  wordsCount: number;
  wordsPerMinute: number;
  wordsLength: number;
}

export const BLIND_READING_PARAMETERS_DECLARATION: ParametersDeclaration = {
  wordsCount: {
    type: 'int',
    default: 10,
    icon: '',
  },
  wordsPerMinute: {
    type: 'int',
    default: 10,
    icon: '',
  },
  wordsLength: {
    type: 'int',
    default: 4,
    icon: '',
  },
};
